import React, {memo, useEffect, useState} from 'react';
import {View, Text, TouchableOpacity, Platform} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';
import {RNEText} from '../../components';

import useStores from '../../stores/useStores';

import {Photo} from '../../server/types/user.types';
import {ProcedureConsultationReqResponse} from '../../server/types/procedure.types';
import {formatShortDate, timestamp} from '../../utils/date.utils';

import {default as ConsultationPhoto} from './ConsultationPhoto';
import {isToday} from 'date-fns';
import {CodedConversationMessages} from '../../server/types/conversation.types';
import { getFullName } from '../../utils/common.utils';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationListItemOngoingProps {
  item: ProcedureConsultationReqResponse;
  onPress?: () => void;
}

const ConsultationListItemOngoing = (
  props: ConsultationListItemOngoingProps,
) => {
  const {authStore} = useStores();

  const [displayName, setDisplayName] = useState('');
  const [displayPhoto, setDisplayPhoto] = useState<Photo>();
  const [displayLatestMessage, setDisplayLatestMessage] = useState('');

  useEffect(() => {
    switch (authStore.userRole) {
      case 'patient':
        if (props.item.performer) {
          setDisplayName(
            `Dr. ${props.item.performer.humanName.given[0]} ${props.item.performer.humanName.family}`,
          );
          setDisplayPhoto(props.item.performer.photo);
        } else {
          setDisplayName('-');
        }
        break;

      case 'practitioner':
        if (props.item.subject) {
         
          setDisplayName(getFullName(props.item.subject.humanName));
          
          setDisplayPhoto(props.item.subject.photo);
        } else {
          setDisplayName('-');
        }
        break;

      default:
        break;
    }

    switch (props.item.note?.text) {
      case CodedConversationMessages.VIDEO_CALL_TRIGGER:
        setDisplayLatestMessage('Video Call Invitation');
        break;

      case CodedConversationMessages.VIDEO_CALL_ACCEPT:
        setDisplayLatestMessage('Video Call Invitation Acceptance');
        break;

      case undefined:
        setDisplayLatestMessage('--');
        break;

      default:
        setDisplayLatestMessage(props.item.note?.text);
        break;
    }
  }, [authStore.userRole, props]);

  const getDisplayLatestMessage = () => {
    if(displayLatestMessage.includes('HCAPPNTMNT_VIDEO_CALL')){
      return 'Video Call'
    }else{
      return displayLatestMessage;
    }
  }

  return (
    <TouchableOpacity activeOpacity={0.75} onPress={props.onPress} style={{padding:totalSize(0), paddingTop:0, paddingBottom:0}} >
      <View style={styles.root}>
        <View style={styles.photo}>
          <ConsultationPhoto photo={displayPhoto} />
        </View>

        <View style={styles.message}>
          <View>
            <RNEText
              label={displayName}
              color="blackLight"
              // weight="600"
              numberOfLines={1}
              ellipsizeMode="tail"
              style={[
                      {fontFamily:'Quicksand-Bold', fontSize: totalSize(1.6)}
                    ]}
            />
          </View>

          <View style={{marginTop: Platform.OS === 'ios' ? height(0.5) : height(0)}}>
            <RNEText
              label={getDisplayLatestMessage()}
              color="#81add0"
              variant="button"
              // weight="400"
              numberOfLines={2}
              ellipsizeMode="tail"
              style={[
                    {fontFamily:'Quicksand-Regular'}
                  ]}
            />
          </View>
        </View>

        <View style={styles.timestamp}>
          <RNEText
                        label={
              isToday(new Date(props.item.note.time))
                ? timestamp(new Date(props.item.note.time))
                : formatShortDate(new Date(props.item.note.time))
            }

            // color="grey"
            color="#81add0"
            variant="button"
            style={{textAlign:'right', fontFamily:'Quicksand-Regular'}}
          />
        </View>
      </View>
    </TouchableOpacity>
  );
}; 

const styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingHorizontal: totalSize(1),
    paddingVertical: totalSize(2.5),
    borderBottomWidth: 1,
    borderBottomColor: colorPalette.light,
    alignItems:'center'
    // paddingVertical: height(2),

  },
  photo: {},
  message: {
    flex: 1,
    paddingHorizontal: 16,
    // paddingTop: 4,
  },
  timestamp: {
    // paddingTop: 4,
    paddingTop: totalSize(0.1),
    alignContent:'flex-end',
    alignItems:'flex-end',
    width: width(28),
    marginRight: width(0.5)
  },
});

export default memo(ConsultationListItemOngoing);
